import { HStack } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, useEffect, useRef } from 'react';

import { Text } from '../../../design-system/typography';
import { rem } from '../../../design-system/utils';

type SlidingTextProps = {
	text: string;
};

const MOTION_PX = 40;

export const SlidingText: FC<SlidingTextProps> = ({ text }) => {
	const isInitialMount = useRef(true);

	// After first render, mark as no longer initial mount
	// This needs to be done in a useEffect hook to ensure it runs after the first render
	useEffect(() => {
		isInitialMount.current = false;
	}, []);

	return (
		<HStack flexGrow={1} h={rem(54)} position="relative">
			<AnimatePresence>
				<motion.div
					key={text}
					initial={isInitialMount.current ? { y: 0, opacity: 1 } : { y: MOTION_PX, opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					exit={{ y: -MOTION_PX, opacity: 0 }}
					transition={{
						duration: 0.3,
						ease: [0.68, -0.3, 0.265, 1.25], // Same cubic-bezier as other animations
					}}
					style={{ position: 'absolute', width: '100%' }}
				>
					<Text size="sm">{text}</Text>
				</motion.div>
			</AnimatePresence>
		</HStack>
	);
};
